import axios from "axios";

export default axios.create({
  baseURL: "https://apis.crm.alpapgroup.com",
});